import { destroy, put } from '@rails/request.js';

import {
  clearCsrfReloadMarker,
  isCsrfRejection,
  reloadOnceForCsrfRejection,
} from '../_utils/csrf-recovery';
import { observableEvent } from '../_utils/observable-event';

async function deleteOnServer({ url, redirect, ...params }) {
  const response = await destroy(url, {
    body: buildFormData(params),
    responseKind: 'json',
  });

  handleResponse(response, redirect);

  try {
    const data = await response.json;
    updateBasketQuantity(data.quantity);
  } catch (e) {}
}

async function updateOnServer({ url, redirect, ...params }) {
  const response = await put(url, {
    body: buildFormData(params),
    responseKind: 'json',
  });

  handleResponse(response, redirect);

  let data;
  try {
    data = await response.json;
    updateBasketQuantity(data.quantity);
  } catch (e) {}
  return data;
}

function buildFormData(params) {
  const formData = new FormData();
  const permittedParams = [
    'size',
    'finish',
    'prism_id',
    'soft',
    'item',
    'quantity',
    'option',
  ];

  Object.entries(params).forEach(([key, value]) => {
    if (permittedParams.includes(key)) {
      if (key === 'quantity') {
        formData.append('values[copies]', value);
      } else {
        formData.append(key, value);
      }
    }
  });

  return formData;
}

function updateBasketQuantity(quantity) {
  if (quantity != null) {
    App.order.set('no_items', quantity);
  }
}

function handleResponse(response, redirect) {
  if (response.ok) {
    clearCsrfReloadMarker();
    return;
  }

  observableEvent.record('cart-server-action-fail', {
    status: response.statusCode,
    url: response.response.url.replace(window.location.origin, ''),
  });

  if (response.statusCode === 404) {
    window.location = redirect;
  }

  if (isCsrfRejection(response)) {
    reloadOnceForCsrfRejection();
  }
}

export { updateOnServer, deleteOnServer };
